import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {ObjectResponse, ObjectsResponse} from "../models/response"

export const objectApi = {
    getObjects(params?: GetParamsType & ObjectsFilterQuery): Promise<CommonResponse<ObjectsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`Object${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getObject(params: GetSingleParamsType): Promise<CommonResponse<ObjectResponse>> {
        const {id, controller} = params
        return instance.get(`Object/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createObject(form: CreateObjectType): Promise<CommonResponse<ObjectResponse>> {
        const {controller, ...rest} = form
        return instance.post(`Object`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeObject(form: ChangeObjectType): Promise<CommonResponse<ObjectResponse>> {
        const {id, controller, ...rest} = form
        return instance.put(`Object/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteObject(id: number): Promise<CommonResponse<boolean>> {
        return instance.delete(`Object/${id}`).then((res: AxiosResponse) => res.data)
    },
    armingObject(params?: ArmingObjectType): Promise<CommonResponse<ObjectResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`Object/arming${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type ObjectsFilterQuery = {
    idCompany?: number
    idObjectGroup?: number
    search?: string
}

export type CreateObjectType = {
    name: string
    address: string
    idObjectGroup: number
    active: boolean
    description: string
    attributes: string
    securityType: string
    securityActive: boolean
} & BaseRequestParams

export type ChangeObjectType = {
    id: number
} & CreateObjectType

export type ArmingObjectType = {
    id: number
    securityActive: boolean
} & BaseRequestParams